__turbopack_context__.v({
  "closeIcon": "styleHamburgerMenu-module-scss-module__wspn_q__closeIcon",
  "demoBtn": "styleHamburgerMenu-module-scss-module__wspn_q__demoBtn",
  "hamburgerButton": "styleHamburgerMenu-module-scss-module__wspn_q__hamburgerButton",
  "hamburgerWrapper": "styleHamburgerMenu-module-scss-module__wspn_q__hamburgerWrapper",
  "menuClose": "styleHamburgerMenu-module-scss-module__wspn_q__menuClose",
  "menuContainer": "styleHamburgerMenu-module-scss-module__wspn_q__menuContainer",
  "menuContent": "styleHamburgerMenu-module-scss-module__wspn_q__menuContent",
  "menuSection": "styleHamburgerMenu-module-scss-module__wspn_q__menuSection",
  "menuSectionTitle": "styleHamburgerMenu-module-scss-module__wspn_q__menuSectionTitle",
  "overlayMenu": "styleHamburgerMenu-module-scss-module__wspn_q__overlayMenu",
  "overlayMenuShow": "styleHamburgerMenu-module-scss-module__wspn_q__overlayMenuShow",
  "selected": "styleHamburgerMenu-module-scss-module__wspn_q__selected",
  "selectorItem": "styleHamburgerMenu-module-scss-module__wspn_q__selectorItem",
  "selectorWrapper": "styleHamburgerMenu-module-scss-module__wspn_q__selectorWrapper",
  "simpleMenuItem": "styleHamburgerMenu-module-scss-module__wspn_q__simpleMenuItem",
  "subSection": "styleHamburgerMenu-module-scss-module__wspn_q__subSection",
  "subSectionLink": "styleHamburgerMenu-module-scss-module__wspn_q__subSectionLink",
  "subSectionLinks": "styleHamburgerMenu-module-scss-module__wspn_q__subSectionLinks",
  "subSectionTitle": "styleHamburgerMenu-module-scss-module__wspn_q__subSectionTitle",
  "subSectionTitleLink": "styleHamburgerMenu-module-scss-module__wspn_q__subSectionTitleLink",
  "topSection": "styleHamburgerMenu-module-scss-module__wspn_q__topSection",
});
